import exportPdf from './exportPdf'
import pages from './pages'

const dashboard = {
  exportPdf,
  pages,
}

export default dashboard
